import { BaseControl } from './base';
import { FormFieldSerializedValue } from '@shared/shared/form-fields';

export class WysiwygControl extends BaseControl {
  serializeValue(formControlValue: any): FormFieldSerializedValue {
    return formControlValue || null;
  }
}
